<template>
  <div class="doc">
    <yu-head/>
    <div class="container">
      <yu-menu/>
      <yu-article>
        <div class="phone">
          <iframe src="http://mobileweb.yurencloud.com/#/result" frameborder="0" width="320" height="580"></iframe>
        </div>


        <div class="title">结果页</div>
        <div class="sub-title">普通用法</div>

        <pre v-highlightjs="code1"><code class="html" ></code></pre>

        <div class="sub-title">属性</div>
        <yu-table :data="attributes1" :widths="widths1"/>

      </yu-article>
    </div>
  </div>
</template>

<script>
import { YuTable } from 'yu.ui';
import { YuButton, YuText } from 'yu.mobile';
import YuHead from './yu-head';
import YuMenu from './yu-menu';
import YuArticle from './yu-article';

export default {
  name: 'Buttons',
  data() {
    return {
      code1: `
  <yu-result title="支付宝支付成功" content="洗面奶：￥98.45" status="alipay"/>
  <yu-result title="微信支付成功" content="洗面奶：￥98.45" status="wechat"/>
  <yu-result title="操作成功" content="已经删除该评论" status="success"/>
  <yu-result title="操作失败" content="您的余额不足" status="fail"/>
  <yu-result title="请等待" content="稍后我们将会联系您" status="wait"/>
  <yu-result title="严重警告" content="不得删除此目录" status="warn"/>
      `,
      attributes1: [
        {
          prop: '参数',
          description: '说明',
          types: '类型',
          default: '默认值',
        },
        {
          prop: 'title',
          description: '标题',
          types: 'String',
          default: '无',
        },
        {
          prop: 'content',
          description: '内容',
          types: 'String',
          default: '无',
        },
        {
          prop: 'status',
          description: '结果页状态',
          types: 'String',
          default: '无',
        },
        {
          prop: 'defaultStatus',
          description: '默认状态显示的图标和颜色',
          types: 'Object',
          default: '{\n' +
          '        alipay: \'icon-alipay primary\',\n' +
          '        wechat: \'icon-wechat success\',\n' +
          '        success: \'icon-check-circle primary\',\n' +
          '        fail: \'icon-close-circle danger\',\n' +
          '        wait: \'icon-clock success\',\n' +
          '        warn: \'icon-warning-circle warming\',\n' +
          '      }',
        },
      ],
      widths1: {
        prop: '150px',
        description: '300px',
        types: '120px',
        default: '200px',
      },
    };
  },
  components: {
    YuHead,
    YuMenu,
    YuArticle,
    YuTable,
    YuButton,
    YuText,
  },
};
</script>

<style lang="scss" scoped type="text/scss">
  @import "../assets/css/varible";

  .doc {
    color: $text;
    height: 100%;
    .container {
      width: 1200px;
      margin: 30px auto;
      .title {
        color: $text;
        font-weight: bold;
        padding: 14px 0;
        margin: 20px 0;
        border-bottom: 1px solid $border;
      }
      .sub-title {
        color: $text;
        padding: 0 8px;
        margin: 20px 0;
        border-left: 4px solid $primary;
      }
    }

    .phone{
      text-align: center;
      iframe {
        margin: 20px auto;
        border-radius: 20px;
        &::-webkit-scrollbar {
          width: 0;
        }
        border: 10px solid $border;

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/result.vue